module.exports = __webpack_public_path__ + "img/k13.e07b2de0.jpg";